import i18next from "i18next";

import { createColumn } from "../../../../../components/Table";
import { getWardLabel } from "../../../../../utils/wardLabel";

export const surveyTableColumns = [
  createColumn({
    keyName: "name",
    header: () => i18next.t("surveys_list_columns_name"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "type",
    header: () => i18next.t("surveys_list_columns_type"),
    cell: (info) => info.renderValue(),
  }),
  createColumn({
    keyName: "assignToHospital",
    header: () =>
      i18next.t("surveys_list_assignWard", { ward: getWardLabel().singular }),
    cell: (info) => info.renderValue(),
    size: 70,
  }),

  createColumn({
    keyName: "edit",
    header: () => i18next.t("surveys_list_columns_edit"),
    cell: (info) => info.renderValue(),
    size: 11,
  }),
];

// A factory, not a constant: getWardLabel() reads the cached hospital configuration, which is
// not populated when this module is first evaluated, and the ward term has to be resolved at
// render anyway so the label follows the active language.
export const getMobileAccordionListColumns = () => [
  {
    key: `${getWardLabel().singular} ID`,
    labelKey: "surveys_list_wardId",
    labelParams: { ward: getWardLabel().singular },
    value: "wardId",
  },
  {
    key: "Survey ID",
    labelKey: "surveys_patientLogin_columns_surveyId",
    value: "id",
  },
];
